// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1A324","bigColWidth":"Table_bigColWidth__3FdPk","biggerColWidth":"Table_biggerColWidth__bA42Q","row":"Table_row__JiyO5","col":"Table_col__1_8yl"};